"use client";

import { GTrendsDetailCard } from "./details-card";
import { GTrendSectorDetails } from "./sector-details";
import { TrendsBarChart } from "./bar-chart";
import {
    Breadcrumb,
    BreadcrumbList,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbSeparator,
    BreadcrumbPage,
} from "@/components/ui/breadcrumb";
import {
    Select,
    SelectTrigger,
    SelectValue,
    SelectContent,
    SelectItem,
} from "@/components/ui/select";
import { Separator } from "@/components/ui/separator";
import dayjs from "dayjs";
import Head from "next/head";
import { useState, useEffect } from "react";
import Image from "next/image";

import logoSDGs from "@/public/images/logo-sdgs.png";
import { Alert, Spin } from "antd";


const leadingComponents = [
    {
        key: "sdgs",
        component: (
            <section className="grid grid-cols-1 lg:grid-cols-5 gap-5">
                <div className="lg:col-span-2">
                    <Image
                        src={logoSDGs}
                        alt="Logo SDGS"
                        className="w-[16rem] mx-auto"
                    ></Image>
                </div>
                <p className="text-gray-800 text-sm leading-6 text-justify lg:col-span-3">
                    <i>Sustainable Development Goals</i> (SDGs) adalah agenda tahun 2030
                    yang merupakan kesepakatan pembangunan berkelanjutan berdasarkan hak
                    asasi manusia dan kesetaraan. Poin umum dari pembangunan
                    berkelanjutan, digunakan sebagai pedoman untuk melaksanakan
                    pembangunan yang menjaga peningkatan kesejahteraan ekonomi masyarakat
                    secara berkesinambungan, pembangunan yang menjaga keberlanjutan
                    kehidupan sosial masyarakat, pembangunan yang menjaga kualitas
                    lingkungan hidup serta pembangunan yang menjamin keadilan dan
                    terlaksananya tata kelola yang mampu menjaga peningkatan kualitas
                    hidup dari satu generasi ke generasi berikutnya. UniTrend menyajikan{" "}
                    <i>keyword-keyword</i> yang berelevansi tinggi terhadap topik mengenai
                    poin SDGs yang populer di Indonesia.
                </p>
            </section>
        ),
    },
];

export const ResearchDisplay = ({ props }: { props: any }) => {
    const [activeSector, setActiveSector] = useState<string>(Object.entries(props.trends)[0][0]);

    useEffect(() => {
        // console.log("CCC", props)
        props && setActiveSector(Object.entries(props.trends)[0][0]);
    }, [props]);

    return (
        <div>
            <div className="min-h-screen bg-white">
                <div className="flex-1">
                    <section
                        style={{
                            backgroundImage: `url(${props.meta["og:Image"] ?? ""})`,
                        }}
                        className="flex flex-col justify-center items-center h-[35vh] max-w-screen bg-cover bg-center shadow-[inset_0_0_0_1920px_rgba(0,0,0,0.5)]"
                    >
                        <div className="px-5 max-w-5xl mx-auto w-full">
                            <h1 className="text-white md:text-[3rem] text-[2em] text-left font-semibold drop-shadow-[0_5px_5px_rgba(255,255,255,0.25)]">
                                {props.meta.title}
                            </h1>
                        </div>
                    </section>
                </div>

                <section className="max-w-5xl mx-auto my-5 p-5">
                    <Alert type="warning" showIcon message={(
                        <p>
                            Kata kunci untuk riset ini tidak akan di update lagi! <strong>Arsip</strong> ini tetap akan dipertahankan dan <strong>Pengolahan Data Otomatis</strong> akan tetap dijalankan namun tidak akan ada pengembangan kata kunci untuk masa mendatang. Untuk riset yang lebih baru, silakan kunjungi{" "}
                            <a href="/gdp" className="text-blue-500 hover:underline">
                                Unitrend GDP Tracker.
                            </a>
                        </p>
                    )} />


                    <Breadcrumb className="my-10">
                        <BreadcrumbList>
                            <BreadcrumbItem>
                                <BreadcrumbLink href="/">Beranda</BreadcrumbLink>
                            </BreadcrumbItem>
                            <BreadcrumbSeparator />
                            <BreadcrumbItem>
                                <BreadcrumbLink href="/riset">Riset</BreadcrumbLink>
                            </BreadcrumbItem>
                            <BreadcrumbSeparator />
                            <BreadcrumbItem>
                                <BreadcrumbPage>{props.meta.title}</BreadcrumbPage>
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>

                    {leadingComponents.find((component) => component.key == props.rkey)?.component}

                    <section className="py-5">
                        <div className="flex">
                            <div className="border-[3px] border-[#004AAB] rounded w-fit flex justify-center items-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={3}
                                    stroke="#004AAB"
                                    className="w-8 h-4 hover:-translate-y-1 transition duration-100 ease-in-out"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"
                                    />
                                </svg>
                            </div>
                            <h1 className="text-[#004AAB] text-xl font-bold text-left w-fit py-3 px-5">
                                Sektor yang mengalami kenaikan
                            </h1>
                        </div>

                        <>
                            <p className="text-black text-xs my-2">
                                Data ini diambil dari Google Trends, dan menunjukkan
                                persentase kenaikan dibandingkan periode yang sama pada tahun
                                sebelumnya.
                            </p>
                            <Spin tip="Loading" size="large" spinning={!!!props}>
                                <TrendsBarChart direction="up" data={props.trends} />
                            </Spin>
                            {/* {props ? (
                                    
                                ) : (
                                    <Loading />
                                )} */}
                        </>

                        <p className="text-gray-400 text-[0.75rem]">
                            Membandingkan :{" "}
                            {`${dayjs()
                                .month(0)
                                .date(1)
                                .subtract(1, "year")
                                .toISOString()
                                .slice(0, 10)} hingga ${dayjs()
                                    .subtract(1, "year")
                                    .toISOString()
                                    .slice(0, 10)}`}{" "}
                            dengan{" "}
                            {`${dayjs()
                                .month(0)
                                .date(1)
                                .toISOString()
                                .slice(0, 10)} hingga ${dayjs()
                                    .toISOString()
                                    .slice(0, 10)}`}{" "}
                        </p>
                        <p className="text-gray-400 text-[0.75rem]">
                            Data terakhir diambil: {props && props.lastCrawl.slice(0, 10)}
                        </p>
                    </section>

                    <section className="py-4 mt-5">
                        <div className="flex">
                            <div className="border-[3px] border-[#F84F07] rounded w-fit flex justify-center items-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={3}
                                    stroke="#F84F07"
                                    className="w-8 h-4 hover:translate-y-1 transition duration-100 ease-in-out"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"
                                    />
                                </svg>
                            </div>
                            <h1 className="text-[#F84F07] text-xl font-bold text-right w-fit py-3 px-5">
                                Sektor yang mengalami penurunan
                            </h1>
                        </div>

                        <>
                            <p className="text-black text-xs my-2">
                                Data ini diambil dari Google Trends, dan menunjukkan
                                persentase penurunan dibandingkan periode yang sama pada tahun
                                sebelumnya.
                            </p>
                            <Spin tip="Loading" size="large" spinning={!!!props}>
                                <TrendsBarChart direction="down" data={props.trends} />
                            </Spin>
                            {/* <div>
                                    {props ? (
                                        <TrendsBarChart direction="down" data={props.trends} />
                                    ) : (
                                        <Loading />
                                    )}
                                </div> */}
                        </>

                        <p className="text-gray-400 text-[0.75rem]">
                            Membandingkan :{" "}
                            {`${dayjs()
                                .month(0)
                                .date(1)
                                .subtract(1, "year")
                                .toISOString()
                                .slice(0, 10)} hingga ${dayjs()
                                    .subtract(1, "year")
                                    .toISOString()
                                    .slice(0, 10)}`}
                            &nbsp;dengan&nbsp;
                            {`${dayjs()
                                .month(0)
                                .date(1)
                                .toISOString()
                                .slice(0, 10)} hingga ${dayjs()
                                    .toISOString()
                                    .slice(0, 10)}`}
                        </p>
                        <p className="text-gray-400 text-[0.75rem]">
                            Data terakhir diambil: {props && props.lastCrawl.slice(0, 10)}
                        </p>
                    </section>

                    <div className="">
                        <p className="text-gray-800 text-sm leading-6 text-justify lg:col-span-3">
                            Penggunaan big data seperti Google Trends dapat membantu
                            pengambil kebijakan dalam memahami kondisi sosial dan ekonomi
                            masyarakat secara cepat, akurat dan real-time. Para investor,
                            misalnya, memanfaatkan Google Trends untuk melihat variasi harga
                            aset global. Seorang investor bisa menentukan diversifikasi
                            portofolio mereka menggunakan informasi item yang ditelusuri
                            melalui Google Trends. Para pekerja komersial atau pengusaha
                            memanfaatkan Google Trends untuk menganalisis pasar, terutama
                            untuk mengukur tren permintaan untuk dijadikan acuan dalam
                            menyusun strategi bisnis. Google Trends juga berperan dalam
                            menciptakan nilai tambah melalui fitur berbasis artificial
                            intelligence untuk membantu membangun platform business to
                            business (B2B) yang efektif.
                            <br />
                            <br />
                            Bagi pengambil kebijakan, data Google Trends dapat memberikan
                            lensa informatif dalam melihat pergeseran minat pencarian Google
                            yang berkaitan dengan isu-isu sosial, ekonomi dan politik saat
                            ini. Google Trends juga dapat digunakan untuk memprediksi
                            pertumbuhan PDB suatu negara bersamaan dengan indikator ekonomi
                            makro lainnya seperti pertumbuhan ekonomi, pengangguran dan
                            inflasi sebagai dasar pengambilan kebijakan. Data tersebut dapat
                            menjadi alternatif peringatan dini bagi pemangku kebijakan untuk
                            menentukan langkah yang akan dicapai dalam mencapai Sustainable
                            Development Goals (SDGs).
                        </p>
                    </div>

                    <Separator className="my-10" />

                    <div className="lg:grid grid-cols-8 gap-10 space-y-10">
                        <div className="block lg:hidden">
                            <h2 className="font-semibold text-xl mb-5">Topik:</h2>
                            <Select onValueChange={(value) => setActiveSector(value)}>
                                <SelectTrigger className="w-full">
                                    <SelectValue placeholder={activeSector} />
                                </SelectTrigger>
                                <SelectContent>
                                    {Object.entries(props.trends).map(
                                        ([key, child], index: number) => (
                                            <SelectItem key={key} value={key}>
                                                {key}
                                            </SelectItem>
                                        )
                                    )}
                                </SelectContent>
                            </Select>
                        </div>

                        <ul className="col-span-2 space-y-2 hidden lg:block">
                            {Object.entries(props.trends).map(
                                ([key, child]: [string, any], index: number) => (
                                    <li
                                        key={index}
                                        className="transition duration-100 ease-in-out hover:scale-105"
                                    >
                                        <GTrendsDetailCard
                                            onClick={setActiveSector}
                                            sector={key}
                                            trend={child.trend}
                                            slug={key
                                                .toLowerCase()
                                                .replace(/,/g, "")
                                                .replace(/ /g, "-")}
                                            trendsChange={child.value}
                                        />
                                    </li>
                                )
                            )}
                        </ul>
                        <div className=" col-span-6">
                            <Spin tip="Loading" size="large" spinning={!!!props}>
                                <GTrendSectorDetails
                                    slug={activeSector}
                                    researchId={props.rkey}
                                />
                            </Spin>
                        </div>
                    </div>

                    {/* {props ? (
                            <div className="lg:grid grid-cols-8 gap-10 space-y-10">
                                <div className="block lg:hidden">
                                    <h2 className="font-semibold text-xl mb-5">Topik:</h2>
                                    <Select onValueChange={(value) => setActiveSector(value)}>
                                        <SelectTrigger className="w-full">
                                            <SelectValue placeholder={activeSector} />
                                        </SelectTrigger>
                                        <SelectContent>
                                            {props &&
                                                Object.entries(props.trends).map(
                                                    ([key, child], index: number) => (
                                                        <SelectItem key={key} value={key}>
                                                            {key}
                                                        </SelectItem>
                                                    )
                                                )}
                                        </SelectContent>
                                    </Select>
                                </div>

                                <ul className="col-span-2 space-y-2 hidden lg:block">
                                    {props &&
                                        Object.entries(props.trends).map(
                                            ([key, child]: any, index: number) => (
                                                <li
                                                    key={index}
                                                    className="transition duration-100 ease-in-out hover:scale-105"
                                                >
                                                    <GTrendsDetailCard
                                                        onClick={setActiveSector}
                                                        sector={key}
                                                        trend={child.trend}
                                                        slug={key
                                                            .toLowerCase()
                                                            .replace(/,/g, "")
                                                            .replace(/ /g, "-")}
                                                        trendsChange={child.value}
                                                    />
                                                </li>
                                            )
                                        )}
                                </ul>
                                <div className=" col-span-6">
                                    {activeSector && (
                                        <GTrendSectorDetails
                                            slug={activeSector}
                                            researchId={props.rkey}
                                        />
                                    )}
                                </div>
                            </div>
                        ) : (
                            <Loading />
                        )} */}
                </section>
            </div>
        </div>

    );
}